import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO, ESTATUS_CANCELADO } from 'utils/constants';

export const baseURI = '/relojchecador/carga-de-reporte/';

/**
 * GET Carga del Report de una semana del Reloj
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCargasReportesRelojPag = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Carga del Report de una semana del Reloj
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCargasReportesReloj = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Carga del Report de una semana del Reloj
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCargaReporteReloj = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

// TO-DO cambiar el url
/**
 * GET  Errores
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const getCargaReporteRelojErrores = async (params) => {
  try {
    const response = await API.get('relojchecador/carga-de-reporte-errores', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Dia Festivo Por Año
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCargaReporteReloj = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Dia Festivo Por Año
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCargaReporteReloj = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Dia Festivo Por Año
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCargaReporteReloj = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Dia Festivo Por Año
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarCargaReporteReloj = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const CancelarCargaReporteReloj = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, { estados_globales: ESTATUS_CANCELADO });
    onSuccess(response, 'Cancelado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/// TO-DO modificar este compa cuando ya este.
/**
 * PUT - Agrega registros a un carga de reporte del reloj ya creado
 * @param {number} id - ID del carga de reporte del reloj
 * @param {object[]} registros - Arreglo de registros
 * @returns {Promise<{}>}
 */
export const putCargaReporteReloj = async (id, registros) => {
  try {
    const response = await API.put(`/relojchecador/agregar-carga-de-reporte/${id}/`, registros);
    onSuccess(response, 'Enviado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
